export const imageCodes = {
    
    heropd1: {
        code: "${merchant}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fc4.png?alt=media&token=a20c0646-dbc3-40d4-990f-db6c00c02b5d"
    },

    heropd2: {
        code: "${merchant}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fc%201.png?alt=media&token=a01541ac-3a04-46b0-9281-dbefd50a4554"
    },

    heropd3: {
        code: "${merchant}_tmpl_img_14",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fc3.png?alt=media&token=d3ef6610-f10f-49ba-aa32-38d3d3ec8de7"
    },

    heropd4: {
        code: "${merchant}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fpp3.png?alt=media&token=d8ac2c60-cc75-4733-8e29-618b15c1cbb7"
    },
}


export const titleCodes = {
    storyTitle: {
        code: "${merchant}_tmpl_title_6",
        title: "The Cetaphil Story"
    },
}


export const textCodes = {

    story1: {
        code: "${merchant}_tmpl_text_15",
        text: "CETAPHIL is a gentle skincare brand that has been recommended and trusted by dermatologists for over 70 years, and is today used by millions of people with sensitive skin from all around the world."
    },

    story2: {
        code: "${merchant}_tmpl_text_16",
        text: "Invented in 1947 by a pioneering pharmacist in Texas, the first product - “Cetaphil Cleansing Lotion“ - known today as Cetaphil Gentle Skin Cleanser - still uses the same formula. Quickly recognized for its gentle cleansing power, the Cetaphil range of products started to grow. Today Cetaphil is available in more than 70 countries worldwide and offers a wide range of everyday products from cleansers, moisturizers to baby products and solutions for sensitive skin conditions."
    },

    story3: {
        code: "${merchant}_tmpl_text_17",
        text: "Specifically formulated to provide effective skincare for a variety of skin types and conditions, Cetaphil has become one of the top skincare brands recommended by dermatologists and other healthcare professionals across the world. In the US, we are proud to be recognized as the #1 Dermatologist Recommended Facial Skincare Brand."
    },

    story4: {
        code: "${merchant}_tmpl_text_18",
        text: "We have worked closely with medical experts to better understand people’s skin needs. This has allowed us to provide different solutions adapted to these needs, and to make the Cetaphil range what it is today."
    },
}
